import { render, staticRenderFns } from "./BigInput.vue?vue&type=template&id=657bc880&scoped=true&"
import script from "./BigInput.vue?vue&type=script&lang=js&"
export * from "./BigInput.vue?vue&type=script&lang=js&"
import style0 from "./BigInput.vue?vue&type=style&index=0&id=657bc880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657bc880",
  null
  
)

export default component.exports